import styled from "styled-components";

export const Steps = styled.div`
max-width: 1167px;
height: 61px;
background-color: rgba(46, 15, 89,1);
border-radius: 10px;
display: flex;
justify-content: space-between;
color: white;
font-size: 30px;
font-weight: 700;
font-style: normal;
font-family: "Roboto";
margin-bottom: 12px;
align-items: center;
padding: 3px;
`;

export const StepDevelopped = styled.div`
    max-width: 1167px;
    min-height: 410px;
    border: 2px solid #2E0F59;
    overflow: auto;
    border-radius: 0px 0px 10px 10px;
    margin-bottom: 12px;
    
`;
export const StepContent = styled.div`
max-width: 1036px;
height: 257px;
padding-left: 20px;
`;

export const TextContent = styled.div`
display: flex;
align-items: center;
`;